import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AnalisesSidebar from './sidebar';

// Componente para análise por clientes
const AnaliseClientes = () => {
    return (
        <Box>
            <Typography variant="h6">Análise por Clientes</Typography>
            {/* Adicione aqui os componentes ou lógica para exibir a análise dos clientes */}
        </Box>
    );
};

// Componente para análise de fornecedores
const AnaliseFornecedores = () => {
    return (
        <Box>
            <Typography variant="h6">Análise de Fornecedores</Typography>
            {/* Adicione aqui os componentes ou lógica para exibir a análise dos fornecedores */}
        </Box>
    );
};

const AnalisesLayout = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'analiseClientes':
                return <AnaliseClientes />;
            case 'analiseFornecedores':
                return <AnaliseFornecedores />;
            default:
                return (
                    <Typography variant="body1" align="center">
                        Selecione uma opção do menu para exibir a análise correspondente.
                    </Typography>
                );
        }
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            {sidebarVisible && (
                <Box
                    sx={{
                        width: '300px',
                        borderRight: '1px solid #ccc',
                        position: 'relative'
                    }}
                >
                    <AnalisesSidebar onOptionChange={handleOptionChange} />
                    {/* Botão para esconder o sidebar */}
                    <IconButton
                        onClick={() => setSidebarVisible(false)}
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '-20px',
                            backgroundColor: 'white',
                            boxShadow: 1
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
            )}
            {/* Botão para mostrar o sidebar quando estiver oculto */}
            {!sidebarVisible && (
                <IconButton
                    onClick={() => setSidebarVisible(true)}
                    sx={{
                        position: 'absolute',
                        left: '0px',
                        top: '50%',
                        backgroundColor: 'white',
                        boxShadow: 1,
                        zIndex: 1
                    }}
                >
                    <ChevronRightIcon />
                </IconButton>
            )}
            <Box sx={{ flexGrow: 1, p: 2 }}>
                {renderContent()}
            </Box>
        </Box>
    );
};

export default AnalisesLayout;
